import {
  ICampaignConfiguration,
  ISavingsGoalConfiguration,
} from '@/dataSource/src/api/payment-link/v2/entities';
import {
  PaymentLinkV2Types,
  TPaymentLinkV2Type,
} from '@/dataSource/src/api/payment-link/v2/types';
import {IPaymentLinkEventData} from '@/services/segment/models/BankingEventModel';

export interface IPaymentLinkTrackData {
  id?: string;
  type?: TPaymentLinkV2Type;
  campaignConfiguration?: ICampaignConfiguration;
  savingsGoalConfiguration?: ISavingsGoalConfiguration;
}

export const buildPaymentLinkPayload = (
  props?: IPaymentLinkTrackData,
): IPaymentLinkEventData => {
  const {id, type, campaignConfiguration, savingsGoalConfiguration} =
    props ?? {};

  if (type === PaymentLinkV2Types.SAVING_GOAL) {
    return {
      id: id ?? '',
      type: type ?? '',
      title: savingsGoalConfiguration?.name ?? '',
      description: savingsGoalConfiguration?.motivation ?? '',
      savings: {
        target: savingsGoalConfiguration?.target,
      },
    };
  }

  return {
    id: id ?? '',
    type: type ?? '',
    title: campaignConfiguration?.title ?? '',
    image: campaignConfiguration?.imageUrl ?? '',
    description: campaignConfiguration?.description ?? '',
    campaign: {
      type: campaignConfiguration?.type ?? '',
    },
    payer: {
      limit: campaignConfiguration?.payerLimit,
    },
    collection: {
      deadline: campaignConfiguration?.collectionDeadline ?? '',
    },
  };
};
